// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Constants
import { FORMAT_DEFAULT } from 'ChartApp/ts/features/fundamental-chart/constants';
// Actions
import { setFundChartFormat } from './format.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const format = createReducer(FORMAT_DEFAULT, on(setChartData, (state, { chartData }) => chartData.params.format), on(setFundChartFormat, (state, { format: newFormat }) => newFormat));
